import { io } from 'socket.io-client';

const SOCKET_URL = 'https://intelebox.onrender.com' || 'http://localhost:5000';

let socket = null;

export const connectSocket = (userId) => {
  if (socket?.connected) return socket;

  socket = io(SOCKET_URL, { transports: ['websocket'], reconnectionAttempts: 5 });

  socket.on('connect', () => {
    socket.emit('authenticate', { userId });
  });

  socket.on('connect_error', (err) => {
    console.warn('Socket connection error:', err.message);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) { socket.disconnect(); socket = null; }
};

export const getSocket = () => socket;
